<template>
  <div>
    <a-spin :spinning="loading3" :indicator="indicator">
      <vxe-table
        border
        row-id="id"
        size="small"
        ref="xTable"
        :data="tableData3"
        align="center"
        header-align="center"
      >
        <vxe-column field="genesymbol" title="Gene name" type="html">
          <template #default="{ row }">
            <a
              @click="goPerturbgene(row.genesymbol, row.datasetid)"
              target="_blank"
              style="color: blue"
              >{{ row.genesymbol }}</a
            >
          </template>
        </vxe-column>
        <!-- <vxe-column field="ensemble" title="Ensembl ID" type="html">
          <template #default="{ row }">
            <a
              :href="
                'https://www.genecards.org/cgi-bin/carddisp.pl?gene=' +
                row.ensemble
              "
              target="_blank"
              style="color: blue"
            >
              {{ row.ensemble }}
            </a>
          </template>
        </vxe-column> -->
        <vxe-column field="datasetid" title="Dataset ID" type="html">
          <template #default="{ row }">
            <a
              @click="goPerturbDataset(row.datasetid)"
              target="_blank"
              style="color: blue"
              >{{ row.datasetid }}</a
            >
          </template>
        </vxe-column>
        <vxe-column field="clusters" title="Perturbation Cluster" type="html">
          <template #default="{ row }">
            <div
              v-if="row.clusters !== null && row.clusters.startsWith('PC')"
              style="text-align: center"
            >
              <a-tag
                color="#4572a7"
                style="margin-bottom: 2px"
                onmouseover="this.style.cursor='pointer'"
                @click="goTOpc(row.clusters)"
              >
                {{ row.clusters }}</a-tag
              >
            </div>
            <div v-else>
              <a-tag>No</a-tag>
            </div>
          </template>
        </vxe-column>
        <vxe-column field="cellline" title="Cell" type="html">
          <!-- <template #default="{ row }">
          <a
            @click="goPerturbDataset(row.datasetid)"
            target="_blank"
            style="color: blue"
            >{{ row.datasetid }}</a
          >
        </template> -->
        </vxe-column>
        <!-- <vxe-column field="cell" title="Cell count" type="html"></vxe-column> -->
        <vxe-column
          field="percentcell"
          title="Perturbation rate"
          type="html"
          :formatter="formatPercentCell"
        >
        </vxe-column>
        <template #empty>
          <span style="color: grey"> No records found! </span>
        </template>
      </vxe-table>

      <vxe-pager
        background
        size="small"
        :loading="loading3"
        :current-page="tablePage3.currentPage"
        :page-size="tablePage3.pageSize"
        :total="tablePage3.totalResult"
        :page-sizes="[5, 10]"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          // 'FullJump',
          // 'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange3"
      >
      </vxe-pager>
    </a-spin>
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";

export default {
  props: ["perturbedgene"],
  data() {
    return {
      indicator: <a-icon type="loading" style="font-size: 50px" spin />,
      //全表搜索
      filterName1: "",
      tempdata: [],
      //分页
      getdata: null, //必须要生成这个data
      loading3: true,
      tableData3: [],
      tablePage3: {
        currentPage: 1,
        pageSize: 5,
        totalResult: 0,
      },
    };
  },
  mounted() {
    axios
      .get("http://research.gzsys.org.cn/perturbdb/API/search/search1.php", {
        params: { key: this.perturbedgene },
      })
      .then((response) => {
        this.getdata = response.data;
        this.findList3(this.getdata);
        this.loading3 = false;
      });
  },

  methods: {
    formatPercentCell({ cellValue }) {
      return String(parseFloat(cellValue).toFixed(2)) + "%";
    },
    //pc跳转
    goTOpc(value) {
      let href =
        "http://research.gzsys.org.cn/perturbdb/#/pcDetails?pcID=" + value;
      window.open(href, "_blank");
    },
    exportDataEvent() {
      if (this.tempdata.length != 0) {
        const list = this.tempdata;
        this.$refs.xTable.exportData({
          filename:
            this.filterName1 +
            "_related_freqTableOf_" +
            this.$route.query.datasetId,
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.getdata;
        this.$refs.xTable.exportData({
          filename: "FreqTableOf_" + this.$route.query.datasetId,
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    goPerturbgene(value1, value2) {
      let routeData = this.$router.resolve({
        name: "perturbedgenes",
        query: { datasetId: value2, gene: value1 },
      });
      window.open(routeData.href, "_blank");
    },
    goPerturbDataset(value) {
      let routeData = this.$router.resolve({
        name: "pubdatasets",
        query: { datasetId: value },
      });
      window.open(routeData.href, "_blank");
    },
    findList3(data) {
      this.loading3 = true;
      setTimeout(() => {
        const list = data;
        this.loading3 = false;
        this.tablePage3.totalResult = list.length;
        this.tableData3 = list.slice(
          (this.tablePage3.currentPage - 1) * this.tablePage3.pageSize,
          this.tablePage3.currentPage * this.tablePage3.pageSize
        );
      }, 300);
    },
    handlePageChange3({ currentPage, pageSize }) {
      this.tablePage3.currentPage = currentPage;
      this.tablePage3.pageSize = pageSize;
      if (this.tempdata.length == 0) {
        this.findList3(this.getdata);
      } else {
        this.findList3(this.tempdata);
      }
    },
    searchEvent1() {
      const filterName = XEUtils.toValueString(this.filterName1)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["genesymbol", "ensgId", "geneId", "datasetId"];
        const rest = this.getdata.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList3(this.tempdata);
      } else {
        this.findList3(this.getdata);
      }
    },
  },
};
</script>
<style scpoed>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
</style>
